import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { urls } from 'helpers/url';
import { navigate } from 'actionCreators';
import { updatePhaseTask } from 'actionCreators/phase';
import PhaseTask from './phase_task';
import PhaseType from 'types/phase';
import TaskType from 'types/task';

export class SchedulingChecklist extends PhaseTask {
  isDisabled = () => false

  onClick = () => (this.props.task.status !== 'complete' ?
    this.props.navigate(urls.phaseSchedulingChecklist(this.props.phase)) :
    this.toggleStatus());
}

SchedulingChecklist.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
};

export const scheduling_checklist = connect(() => state => ({
  user: state.user,
}), { updatePhaseTask, navigate })(SchedulingChecklist);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/scheduling_checklist.jsx